import { MessageTemplateKey } from './Interfaces';

export const DateConstants = {
    DATE_FORMAT_SHOW: 'DD/MM/YYYY',
    CALENDAR_DATE_FORMAT: 'dd/mm/yy',
    SERVER_NODATIME_INSTANT_FORMAT: 'YYYY-MM-DDTHH:mm:ss[Z]',
    SERVER_NODATIME_LOCAL_DATE_FORMAT: 'YYYY-MM-DD',
    SERVER_NODATIME_LOCAL_DATE_TIME_FORMAT: 'YYYY-MM-DDTHH:mm:ss'
};

export const MESSAGE_TEMPLATE_KEYS_FOR_ORDERS: MessageTemplateKey[] = [
    { key: '[LAST NAME]', label: 'sms-email-management.template.last-name' },
    { key: '[FIRST NAME]', label: 'sms-email-management.template.first-name' },
    { key: '[FULL NAME]', label: 'sms-email-management.template.full-name' },
    { key: '[PRODUCT NAME]', label: 'sms-email-management.template.product-name' }
];

export const MESSAGE_TEMPLATE_KEYS_FOR_CRM_CUSTOMERS: MessageTemplateKey[] = MESSAGE_TEMPLATE_KEYS_FOR_ORDERS.filter(
    k => k.key !== '[PRODUCT NAME]'
);

export const VIRTUAL_SLOT_ID = 'aNbR11z8'; // int.MaxValue hashed
export const FAKE_SLOT_ID_PREFIX = 'fake-slot-id:';
